export enum QuestionnaireItemAnswerType {
    options = 'options',
    string = 'string',
}
